import { getStoredUser } from "./authStorage";

/**
 * Permission keys from GET /permissions (and login `data.permissions`).
 * Used for SideNav visibility + route guards + CRUD buttons.
 */
export const PERMISSIONS = {
  VIEW_DASHBOARD: "view_dashboard",
  VIEW_PERMISSIONS: "view_permissions",
  SHOW_PERMISSIONS: "show_permissions",
  CREATE_PERMISSIONS: "create_permissions",
  EDIT_PERMISSIONS: "edit_permissions",
  DELETE_PERMISSIONS: "delete_permissions",
  VIEW_ROLES: "view_roles",
  SHOW_ROLES: "show_roles",
  CREATE_ROLES: "create_roles",
  EDIT_ROLES: "edit_roles",
  DELETE_ROLES: "delete_roles",
  VIEW_SETTINGS: "view_settings",
  SHOW_SETTINGS: "show_settings",
  CREATE_SETTINGS: "create_settings",
  EDIT_SETTINGS: "edit_settings",
  DELETE_SETTINGS: "delete_settings",

  VIEW_DEPARTMENTS: "view_departments",
  SHOW_DEPARTMENTS: "show_departments",
  CREATE_DEPARTMENTS: "create_departments",
  EDIT_DEPARTMENTS: "edit_departments",
  DELETE_DEPARTMENTS: "delete_departments",
  VIEW_EMPLOYEES: "view_employees",
  SHOW_EMPLOYEES: "show_employees",
  CREATE_EMPLOYEES: "create_employees",
  EDIT_EMPLOYEES: "edit_employees",
  DELETE_EMPLOYEES: "delete_employees",

  VIEW_PARTNERS: "view_partners",
  SHOW_PARTNERS: "show_partners",
  CREATE_PARTNERS: "create_partners",
  EDIT_PARTNERS: "edit_partners",
  DELETE_PARTNERS: "delete_partners",
  VIEW_DRIVERS: "view_drivers",
  SHOW_DRIVERS: "show_drivers",
  CREATE_DRIVERS: "create_drivers",
  EDIT_DRIVERS: "edit_drivers",
  DELETE_DRIVERS: "delete_drivers",
  EXPORT_DRIVERS: "export_drivers",
  VIEW_PARTNER_VEHICLES: "view_partner_vehicles",
  SHOW_PARTNER_VEHICLES: "show_partner_vehicles",
  CREATE_PARTNER_VEHICLES: "create_partner_vehicles",
  DELETE_PARTNER_VEHICLES: "delete_partner_vehicles",

  VIEW_RENTAL_MANAGEMENT: "view_rental_management",
  SHOW_RENTAL_MANAGEMENT: "show_rental_management",
  CREATE_RENTAL_MANAGEMENT: "create_rental_management",
  EDIT_RENTAL_MANAGEMENT: "edit_rental_management",
  DELETE_RENTAL_MANAGEMENT: "delete_rental_management",
  EXPORT_RENTAL_MANAGEMENT: "export_rental_management",
  VIEW_LEASE_CONTRACTS: "view_lease_contracts",
  SHOW_LEASE_CONTRACTS: "show_lease_contracts",
  CREATE_LEASE_CONTRACTS: "create_lease_contracts",
  EDIT_LEASE_CONTRACTS: "edit_lease_contracts",
  DELETE_LEASE_CONTRACTS: "delete_lease_contracts",

  VIEW_FLEET_CONTRACTS: "view_fleet_contracts",
  SHOW_FLEET_CONTRACTS: "show_fleet_contracts",
  CREATE_FLEET_CONTRACTS: "create_fleet_contracts",
  EDIT_FLEET_CONTRACTS: "edit_fleet_contracts",
  DELETE_FLEET_CONTRACTS: "delete_fleet_contracts",
  VIEW_VEHICLES: "view_vehicles",
  SHOW_VEHICLES: "show_vehicles",
  CREATE_VEHICLES: "create_vehicles",
  EDIT_VEHICLES: "edit_vehicles",
  DELETE_VEHICLES: "delete_vehicles",
  EXPORT_VEHICLES: "export_vehicles",

  VIEW_JOURNAL_ENTRIES: "view_journal_entries",
  SHOW_JOURNAL_ENTRIES: "show_journal_entries",
  CREATE_JOURNAL_ENTRIES: "create_journal_entries",
  EDIT_JOURNAL_ENTRIES: "edit_journal_entries",
  DELETE_JOURNAL_ENTRIES: "delete_journal_entries",
  VIEW_CHART_ACCOUNTS: "view_chart_accounts",
  SHOW_CHART_ACCOUNTS: "show_chart_accounts",
  CREATE_CHART_ACCOUNTS: "create_chart_accounts",
  EDIT_CHART_ACCOUNTS: "edit_chart_accounts",
  DELETE_CHART_ACCOUNTS: "delete_chart_accounts",
  VIEW_BONDS: "view_bonds",
  SHOW_BONDS: "show_bonds",
  CREATE_BONDS: "create_bonds",
  EDIT_BONDS: "edit_bonds",
  DELETE_BONDS: "delete_bonds",
  EXPORT_BONDS: "export_bonds",
  VIEW_PURCHASE_INVOICES: "view_purchase_invoices",
  SHOW_PURCHASE_INVOICES: "show_purchase_invoices",
  CREATE_PURCHASE_INVOICES: "create_purchase_invoices",
  EDIT_PURCHASE_INVOICES: "edit_purchase_invoices",
  DELETE_PURCHASE_INVOICES: "delete_purchase_invoices",
  EXPORT_PURCHASE_INVOICES: "export_purchase_invoices",
  VIEW_SALES_INVOICES: "view_sales_invoices",
  SHOW_SALES_INVOICES: "show_sales_invoices",
  CREATE_SALES_INVOICES: "create_sales_invoices",
  EDIT_SALES_INVOICES: "edit_sales_invoices",
  DELETE_SALES_INVOICES: "delete_sales_invoices",
  EXPORT_SALES_INVOICES: "export_sales_invoices",

  VIEW_QUOTATIONS: "view_quotations",
  SHOW_QUOTATIONS: "show_quotations",
  CREATE_QUOTATIONS: "create_quotations",
  EDIT_QUOTATIONS: "edit_quotations",
  DELETE_QUOTATIONS: "delete_quotations",
  VIEW_TARGET_CUSTOMERS: "view_target_customers",
  SHOW_TARGET_CUSTOMERS: "show_target_customers",
  VIEW_LEADS: "view_leads",
  SHOW_LEADS: "show_leads",
  CREATE_LEADS: "create_leads",
  EDIT_LEADS: "edit_leads",
  DELETE_LEADS: "delete_leads",
  VIEW_BUSINESS_SECTORS: "view_business_sectors",
  SHOW_BUSINESS_SECTORS: "show_business_sectors",
  CREATE_BUSINESS_SECTORS: "create_business_sectors",
  EDIT_BUSINESS_SECTORS: "edit_business_sectors",
  DELETE_BUSINESS_SECTORS: "delete_business_sectors",
  EXPORT_BUSINESS_SECTORS: "export_business_sectors",
  VIEW_CLIENTS: "view_clients",
  SHOW_CLIENTS: "show_clients",
  CREATE_CLIENTS: "create_clients",
  EDIT_CLIENTS: "edit_clients",
  DELETE_CLIENTS: "delete_clients",

  VIEW_TRAVEL_COMPENSATIONS: "view_travel_compensations",
  SHOW_TRAVEL_COMPENSATIONS: "show_travel_compensations",
  EDIT_TRAVEL_COMPENSATIONS: "edit_travel_compensations",
  VIEW_TRIP_OFFERS: "view_trip_offers",
  SHOW_TRIP_OFFERS: "show_trip_offers",
  CREATE_TRIP_OFFERS: "create_trip_offers",
  VIEW_TRAVEL_REQUESTS: "view_travel_requests",
  SHOW_TRAVEL_REQUESTS: "show_travel_requests",
  CREATE_TRAVEL_REQUESTS: "create_travel_requests",
  EDIT_TRAVEL_REQUESTS: "edit_travel_requests",
  DELETE_TRAVEL_REQUESTS: "delete_travel_requests",
  EXPORT_TRAVEL_REQUESTS: "export_travel_requests",
  DELETE_MANUAL_GROUPED_ORDERS: "delete_manual_grouped_orders",

  VIEW_EXPORT_ORDERS: "view_export_orders",

  VIEW_RECEIPT_DOCUMENTS: "view_receipt_documents",
  EDIT_RECEIPT_DOCUMENTS: "edit_receipt_documents",
  DELETE_RECEIPT_DOCUMENTS: "delete_receipt_documents",
  EXPORT_RECEIPT_DOCUMENTS: "export_receipt_documents",

  VIEW_REPORTS: "view_reports",
  EXPORT_REPORTS: "export_reports",
};

/**
 * Normalize login / API permission entries into string keys.
 * @param {unknown} list
 * @returns {string[]}
 */
export function normalizePermissionKeys(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((item) => {
      if (typeof item === "string") return item.trim();
      if (item && typeof item === "object") {
        const key = item.permission ?? item.name_en ?? item.key;
        return typeof key === "string" ? key.trim() : "";
      }
      return "";
    })
    .filter(Boolean);
}

/**
 * @param {unknown} user — login `data` object or stored userElwnsh
 * @returns {{ enforce: boolean, keys: Set<string> }}
 */
export function getPermissionStateFromUser(user) {
  if (!user || typeof user !== "object") {
    return { enforce: false, keys: new Set() };
  }
  if (!Object.prototype.hasOwnProperty.call(user, "permissions")) {
    return { enforce: false, keys: new Set() };
  }
  return {
    enforce: true,
    keys: new Set(normalizePermissionKeys(user.permissions)),
  };
}

export function getStoredPermissionState() {
  return getPermissionStateFromUser(getStoredUser());
}

/**
 * @param {string | string[] | null | undefined} required
 * @param {Set<string>} keys
 * @param {{ enforce?: boolean, mode?: 'any' | 'all' }} [opts]
 */
export function checkPermission(required, keys, opts = {}) {
  const { enforce = true, mode = "any" } = opts;
  if (!enforce) return true;
  if (required == null) return true;
  const list = (Array.isArray(required) ? required : [required]).filter(Boolean);
  if (list.length === 0) return true;
  if (!(keys instanceof Set)) return false;
  if (mode === "all") return list.every((p) => keys.has(p));
  return list.some((p) => keys.has(p));
}

/**
 * Detect CRUD intent from a URL path segment pattern.
 * /client_offers → view (list)
 * /client_offers/view/5 → show (details)
 * /show_driver/5 → show
 * /client_offers/add → create
 * /client_offers/edit/5 → edit
 *
 * @param {string} pathname
 * @returns {'view' | 'show' | 'create' | 'edit'}
 */
export function detectPathAction(pathname) {
  const path = (pathname || "").split("?")[0] || "/";
  const parts = path.split("/").filter(Boolean);

  for (const part of parts) {
    const p = part.toLowerCase();
    if (p === "edit" || p.startsWith("edit_")) return "edit";
    if (
      p === "add" ||
      p.startsWith("add_") ||
      p === "create" ||
      p.startsWith("create_")
    ) {
      return "create";
    }
    if (
      p === "view" ||
      p.startsWith("view_") ||
      p === "show" ||
      p.startsWith("show_")
    ) {
      return "show";
    }
  }
  return "view";
}

/**
 * Module route rules. Longest `path` wins.
 * `actions` separates view / create / edit so `/module/add` does NOT inherit view_*.
 */
export const ROUTE_PERMISSION_RULES = [
  { path: "/", exact: true, actions: { view: PERMISSIONS.VIEW_DASHBOARD } },

  {
    path: "/permissions",
    actions: {
      view: PERMISSIONS.VIEW_PERMISSIONS,
      show: PERMISSIONS.SHOW_PERMISSIONS,
      create: PERMISSIONS.CREATE_PERMISSIONS,
      edit: PERMISSIONS.EDIT_PERMISSIONS,
    },
  },
  { path: "/add_permission", actions: { view: PERMISSIONS.CREATE_PERMISSIONS, create: PERMISSIONS.CREATE_PERMISSIONS } },
  { path: "/edit_permission", actions: { view: PERMISSIONS.EDIT_PERMISSIONS, edit: PERMISSIONS.EDIT_PERMISSIONS } },

  {
    path: "/roles",
    actions: {
      view: PERMISSIONS.VIEW_ROLES,
      show: PERMISSIONS.SHOW_ROLES,
      create: PERMISSIONS.CREATE_ROLES,
      edit: PERMISSIONS.EDIT_ROLES,
    },
  },
  { path: "/add_user_role", actions: { view: PERMISSIONS.CREATE_ROLES, create: PERMISSIONS.CREATE_ROLES } },
  { path: "/edit_user_role", actions: { view: PERMISSIONS.EDIT_ROLES, edit: PERMISSIONS.EDIT_ROLES } },
  { path: "/show_user_role", actions: { view: PERMISSIONS.SHOW_ROLES, show: PERMISSIONS.SHOW_ROLES } },

  // Settings family
  ...[
    "/main_settings",
    "/service_categories",
    "/services_categories",
    "/services_types",
    "/compensation_categories",
    "/AttachmentsType",
    "/file_archive_types",
    "/load_types",
    "/good_types",
    "/order_issue_types",
    "/edit_GoogleMapLinks",
    "/Positions",
    "/Offices",
    "/fleet_management_types",
    "/document_type",
    "/vehicle_companies",
    "/office_document_type",
    "/furniture_questions",
    "/quotation_features",
    "/category_rush_hours",
    "/car_departments",
    "/countries",
    "/cities",
    "/region",
  ].map((path) => ({
    path,
    actions: {
      view: PERMISSIONS.VIEW_SETTINGS,
      show: PERMISSIONS.SHOW_SETTINGS,
      create: PERMISSIONS.CREATE_SETTINGS,
      edit: PERMISSIONS.EDIT_SETTINGS,
    },
  })),
  {
    path: "/company_managements",
    actions: {
      view: PERMISSIONS.VIEW_DEPARTMENTS,
      show: PERMISSIONS.SHOW_DEPARTMENTS,
      create: PERMISSIONS.CREATE_DEPARTMENTS,
      edit: PERMISSIONS.EDIT_DEPARTMENTS,
    },
  },
  {
    path: "/job_company_managements",
    actions: {
      view: PERMISSIONS.VIEW_DEPARTMENTS,
      show: PERMISSIONS.SHOW_DEPARTMENTS,
      create: PERMISSIONS.CREATE_DEPARTMENTS,
      edit: PERMISSIONS.EDIT_DEPARTMENTS,
    },
  },
  // Standalone settings create/edit URLs
  ...[
    "/add_services_types",
    "/add_file_archive_types",
    "/add_load_types",
    "/add_good_types",
    "/add_order_issue_types",
    "/add_fleet_management_type",
    "/add_document_type",
    "/add_vehicle_companies",
    "/add_furniture_questions",
    "/add_quotation_features",
    "/add_car_department",
  ].map((path) => ({
    path,
    actions: { view: PERMISSIONS.CREATE_SETTINGS, create: PERMISSIONS.CREATE_SETTINGS },
  })),
  ...[
    "/edit_services_types",
    "/edit_file_archive_types",
    "/edit_load_types",
    "/edit_good_types",
    "/edit_order_issue_types",
    "/edit_fleet_management_type",
    "/edit_document_type",
    "/edit_vehicle_companies",
    "/edit_furniture_questions",
    "/edit_quotation_features",
    "/edit_category_rush_hours",
    "/edit_car_department",
  ].map((path) => ({
    path,
    actions: { view: PERMISSIONS.EDIT_SETTINGS, edit: PERMISSIONS.EDIT_SETTINGS },
  })),

  {
    path: "/employees",
    actions: {
      view: PERMISSIONS.VIEW_EMPLOYEES,
      show: PERMISSIONS.SHOW_EMPLOYEES,
      create: PERMISSIONS.CREATE_EMPLOYEES,
      edit: PERMISSIONS.EDIT_EMPLOYEES,
    },
  },
  { path: "/add_employees", actions: { view: PERMISSIONS.CREATE_EMPLOYEES, create: PERMISSIONS.CREATE_EMPLOYEES } },
  { path: "/edit_employee", actions: { view: PERMISSIONS.EDIT_EMPLOYEES, edit: PERMISSIONS.EDIT_EMPLOYEES } },
  { path: "/show_employee", actions: { view: PERMISSIONS.SHOW_EMPLOYEES, show: PERMISSIONS.SHOW_EMPLOYEES } },
  { path: "/teamwork-movements", actions: { view: PERMISSIONS.VIEW_EMPLOYEES,
      show: PERMISSIONS.SHOW_EMPLOYEES } },

  {
    path: "/clients",
    actions: {
      view: PERMISSIONS.VIEW_CLIENTS,
      show: PERMISSIONS.SHOW_CLIENTS,
      create: PERMISSIONS.CREATE_CLIENTS,
      edit: PERMISSIONS.EDIT_CLIENTS,
    },
  },
  {
    path: "/business_sector",
    actions: {
      view: PERMISSIONS.VIEW_BUSINESS_SECTORS,
      show: PERMISSIONS.SHOW_BUSINESS_SECTORS,
      create: PERMISSIONS.CREATE_BUSINESS_SECTORS,
      edit: PERMISSIONS.EDIT_BUSINESS_SECTORS,
    },
  },
  {
    path: "/business-sector-contracts",
    actions: {
      view: PERMISSIONS.VIEW_BUSINESS_SECTORS,
      show: PERMISSIONS.SHOW_BUSINESS_SECTORS,
      create: PERMISSIONS.CREATE_BUSINESS_SECTORS,
      edit: PERMISSIONS.EDIT_BUSINESS_SECTORS,
    },
  },
  {
    path: "/business-sector-users",
    actions: {
      view: PERMISSIONS.VIEW_BUSINESS_SECTORS,
      show: PERMISSIONS.SHOW_BUSINESS_SECTORS,
      create: PERMISSIONS.CREATE_BUSINESS_SECTORS,
      edit: PERMISSIONS.EDIT_BUSINESS_SECTORS,
    },
  },
  {
    path: "/leads",
    actions: {
      view: PERMISSIONS.VIEW_LEADS,
      show: PERMISSIONS.SHOW_LEADS,
      create: PERMISSIONS.CREATE_LEADS,
      edit: PERMISSIONS.EDIT_LEADS,
      delete: PERMISSIONS.DELETE_LEADS,
    },
  },
  { path: "/target_customers", actions: { view: PERMISSIONS.VIEW_TARGET_CUSTOMERS,
      show: PERMISSIONS.SHOW_TARGET_CUSTOMERS } },

  {
    path: "/tripway_partners_list",
    actions: {
      view: PERMISSIONS.VIEW_PARTNERS,
      show: PERMISSIONS.SHOW_PARTNERS,
      create: PERMISSIONS.CREATE_PARTNERS,
      edit: PERMISSIONS.EDIT_PARTNERS,
    },
  },
  { path: "/add_tripway_partner", actions: { view: PERMISSIONS.CREATE_PARTNERS, create: PERMISSIONS.CREATE_PARTNERS } },
  { path: "/edit_tripway_partner", actions: { view: PERMISSIONS.EDIT_PARTNERS, edit: PERMISSIONS.EDIT_PARTNERS } },
  { path: "/show_tripway_partner", actions: { view: PERMISSIONS.SHOW_PARTNERS, show: PERMISSIONS.SHOW_PARTNERS } },
  {
    path: "/users_winch_partners",
    actions: {
      view: PERMISSIONS.VIEW_PARTNERS,
      show: PERMISSIONS.SHOW_PARTNERS,
      create: PERMISSIONS.CREATE_PARTNERS,
      edit: PERMISSIONS.EDIT_PARTNERS,
    },
  },
  { path: "/partners_contracts", actions: { view: PERMISSIONS.VIEW_PARTNERS,
      show: PERMISSIONS.SHOW_PARTNERS, create: PERMISSIONS.CREATE_PARTNERS, edit: PERMISSIONS.EDIT_PARTNERS } },
  { path: "/partners_docs", actions: { view: PERMISSIONS.VIEW_PARTNERS,
      show: PERMISSIONS.SHOW_PARTNERS, create: PERMISSIONS.CREATE_PARTNERS, edit: PERMISSIONS.EDIT_PARTNERS } },
  { path: "/winch-partner-documents", actions: { view: PERMISSIONS.VIEW_PARTNERS,
      show: PERMISSIONS.SHOW_PARTNERS, create: PERMISSIONS.CREATE_PARTNERS, edit: PERMISSIONS.EDIT_PARTNERS } },
  { path: "/winch-partner-contracts", actions: { view: PERMISSIONS.VIEW_PARTNERS,
      show: PERMISSIONS.SHOW_PARTNERS, create: PERMISSIONS.CREATE_PARTNERS, edit: PERMISSIONS.EDIT_PARTNERS } },
  { path: "/docs_carriers", actions: { view: PERMISSIONS.VIEW_PARTNERS,
      show: PERMISSIONS.SHOW_PARTNERS } },
  { path: "/add_role", actions: { view: PERMISSIONS.CREATE_PARTNERS, create: PERMISSIONS.CREATE_PARTNERS } },
  { path: "/edit_role", actions: { view: PERMISSIONS.EDIT_PARTNERS, edit: PERMISSIONS.EDIT_PARTNERS } },
  { path: "/user_permissions", actions: { view: PERMISSIONS.VIEW_PARTNERS,
      show: PERMISSIONS.SHOW_PARTNERS } },

  {
    path: "/drivers",
    actions: {
      view: PERMISSIONS.VIEW_DRIVERS,
      show: PERMISSIONS.SHOW_DRIVERS,
      create: PERMISSIONS.CREATE_DRIVERS,
      edit: PERMISSIONS.EDIT_DRIVERS,
    },
  },
  { path: "/add_driver", actions: { view: PERMISSIONS.CREATE_DRIVERS, create: PERMISSIONS.CREATE_DRIVERS } },
  { path: "/edit_driver", actions: { view: PERMISSIONS.EDIT_DRIVERS, edit: PERMISSIONS.EDIT_DRIVERS } },
  { path: "/show_driver", actions: { view: PERMISSIONS.SHOW_DRIVERS, show: PERMISSIONS.SHOW_DRIVERS } },
  {
    path: "/vehicles_plural",
    actions: {
      view: PERMISSIONS.VIEW_PARTNER_VEHICLES,
      show: PERMISSIONS.SHOW_PARTNER_VEHICLES,
      create: PERMISSIONS.CREATE_PARTNER_VEHICLES,
      edit: PERMISSIONS.CREATE_PARTNER_VEHICLES,
    },
  },

  {
    path: "/trip_requests",
    actions: {
      view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS,
      create: PERMISSIONS.CREATE_TRAVEL_REQUESTS,
      edit: PERMISSIONS.EDIT_TRAVEL_REQUESTS,
    },
  },
  {
    path: "/compensation_approvals",
    actions: {
      view: PERMISSIONS.VIEW_TRAVEL_COMPENSATIONS,
      show: PERMISSIONS.SHOW_TRAVEL_COMPENSATIONS,
      edit: PERMISSIONS.EDIT_TRAVEL_COMPENSATIONS,
    },
  },
  { path: "/documents_files", actions: { view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS } },
  {
    path: "/trip_requests/receive-documents",
    actions: {
      view: PERMISSIONS.VIEW_RECEIPT_DOCUMENTS,
      show: PERMISSIONS.VIEW_RECEIPT_DOCUMENTS,
      edit: PERMISSIONS.EDIT_RECEIPT_DOCUMENTS,
      create: PERMISSIONS.EDIT_RECEIPT_DOCUMENTS,
      delete: PERMISSIONS.DELETE_RECEIPT_DOCUMENTS,
    },
  },
  { path: "/internal_requests", actions: { view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS } },
  { path: "/order_issue_reports", actions: { view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS } },
  { path: "/order_document_reception", actions: {
      view: PERMISSIONS.VIEW_RECEIPT_DOCUMENTS,
      show: PERMISSIONS.VIEW_RECEIPT_DOCUMENTS,
      edit: PERMISSIONS.EDIT_RECEIPT_DOCUMENTS,
    } },
  { path: "/order_summary", actions: { view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS } },
  { path: "/edit_order_details", actions: { view: PERMISSIONS.EDIT_TRAVEL_REQUESTS, edit: PERMISSIONS.EDIT_TRAVEL_REQUESTS } },
  { path: "/edit_order_prices", actions: { view: PERMISSIONS.EDIT_TRAVEL_REQUESTS, edit: PERMISSIONS.EDIT_TRAVEL_REQUESTS } },
  { path: "/edit_shipment_numbers", actions: { view: PERMISSIONS.EDIT_TRAVEL_REQUESTS, edit: PERMISSIONS.EDIT_TRAVEL_REQUESTS } },
  { path: "/trip_reports", actions: { view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS } },
  { path: "/duplicate_shipment_numbers", actions: { view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS } },
  { path: "/late_entries", actions: { view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS } },
  {
    path: "/transport_documents",
    actions: {
      view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS,
      create: PERMISSIONS.CREATE_TRAVEL_REQUESTS,
      edit: PERMISSIONS.EDIT_TRAVEL_REQUESTS,
    },
  },
  {
    path: "/manual_grouped_orders",
    actions: {
      view: PERMISSIONS.VIEW_TRAVEL_REQUESTS,
      show: PERMISSIONS.SHOW_TRAVEL_REQUESTS,
      create: PERMISSIONS.CREATE_TRAVEL_REQUESTS,
      edit: PERMISSIONS.EDIT_TRAVEL_REQUESTS,
      delete: PERMISSIONS.DELETE_MANUAL_GROUPED_ORDERS,
    },
  },
  {
    path: "/export_orders",
    actions: { view: PERMISSIONS.VIEW_EXPORT_ORDERS },
  },

  {
    path: "/rental_requests",
    actions: {
      view: PERMISSIONS.VIEW_RENTAL_MANAGEMENT,
      show: PERMISSIONS.SHOW_RENTAL_MANAGEMENT,
      create: PERMISSIONS.CREATE_RENTAL_MANAGEMENT,
      edit: PERMISSIONS.EDIT_RENTAL_MANAGEMENT,
    },
  },
  {
    path: "/rental_projects_main",
    actions: {
      view: PERMISSIONS.VIEW_RENTAL_MANAGEMENT,
      show: PERMISSIONS.SHOW_RENTAL_MANAGEMENT,
      create: PERMISSIONS.CREATE_RENTAL_MANAGEMENT,
      edit: PERMISSIONS.EDIT_RENTAL_MANAGEMENT,
    },
  },
  {
    path: "/rental_orders_main",
    actions: {
      view: PERMISSIONS.VIEW_RENTAL_MANAGEMENT,
      show: PERMISSIONS.SHOW_RENTAL_MANAGEMENT,
      create: PERMISSIONS.CREATE_RENTAL_MANAGEMENT,
      edit: PERMISSIONS.EDIT_RENTAL_MANAGEMENT,
    },
  },
  {
    path: "/rental_contracts_main",
    actions: {
      view: PERMISSIONS.VIEW_LEASE_CONTRACTS,
      show: PERMISSIONS.SHOW_LEASE_CONTRACTS,
      create: PERMISSIONS.CREATE_LEASE_CONTRACTS,
      edit: PERMISSIONS.EDIT_LEASE_CONTRACTS,
    },
  },
  {
    path: "/rental_contracts",
    actions: {
      view: PERMISSIONS.VIEW_LEASE_CONTRACTS,
      show: PERMISSIONS.SHOW_LEASE_CONTRACTS,
      create: PERMISSIONS.CREATE_LEASE_CONTRACTS,
      edit: PERMISSIONS.EDIT_LEASE_CONTRACTS,
    },
  },
  { path: "/rental_request_summary", actions: { view: PERMISSIONS.VIEW_RENTAL_MANAGEMENT,
      show: PERMISSIONS.SHOW_RENTAL_MANAGEMENT } },
  { path: "/rental_reports", actions: { view: PERMISSIONS.VIEW_RENTAL_MANAGEMENT,
      show: PERMISSIONS.SHOW_RENTAL_MANAGEMENT } },
  {
    path: "/leasing_request",
    actions: {
      view: PERMISSIONS.VIEW_RENTAL_MANAGEMENT,
      show: PERMISSIONS.SHOW_RENTAL_MANAGEMENT,
      create: PERMISSIONS.CREATE_RENTAL_MANAGEMENT,
      edit: PERMISSIONS.EDIT_RENTAL_MANAGEMENT,
    },
  },
  { path: "/add_leasing_maintenance", actions: { view: PERMISSIONS.CREATE_RENTAL_MANAGEMENT, create: PERMISSIONS.CREATE_RENTAL_MANAGEMENT } },
  { path: "/edit_leasing_maintenance", actions: { view: PERMISSIONS.EDIT_RENTAL_MANAGEMENT, edit: PERMISSIONS.EDIT_RENTAL_MANAGEMENT } },
  { path: "/view_leasing_maintenance", actions: { view: PERMISSIONS.SHOW_RENTAL_MANAGEMENT, show: PERMISSIONS.SHOW_RENTAL_MANAGEMENT } },

  {
    path: "/maintenance",
    actions: {
      view: PERMISSIONS.VIEW_VEHICLES,
      show: PERMISSIONS.SHOW_VEHICLES,
      create: PERMISSIONS.CREATE_VEHICLES,
      edit: PERMISSIONS.EDIT_VEHICLES,
    },
  },
  {
    path: "/fuel",
    actions: {
      view: PERMISSIONS.VIEW_VEHICLES,
      show: PERMISSIONS.SHOW_VEHICLES,
      create: PERMISSIONS.CREATE_VEHICLES,
      edit: PERMISSIONS.EDIT_VEHICLES,
    },
  },
  { path: "/vehicle_statement", actions: { view: PERMISSIONS.VIEW_VEHICLES,
      show: PERMISSIONS.SHOW_VEHICLES } },
  { path: "/add_maintenance_request", actions: { view: PERMISSIONS.CREATE_VEHICLES, create: PERMISSIONS.CREATE_VEHICLES } },
  { path: "/add_fuel_request", actions: { view: PERMISSIONS.CREATE_VEHICLES, create: PERMISSIONS.CREATE_VEHICLES } },
  { path: "/edit_fuel", actions: { view: PERMISSIONS.EDIT_VEHICLES, edit: PERMISSIONS.EDIT_VEHICLES } },
  { path: "/view_fuel", actions: { view: PERMISSIONS.SHOW_VEHICLES, show: PERMISSIONS.SHOW_VEHICLES } },
  { path: "/add_entry", actions: { view: PERMISSIONS.CREATE_VEHICLES, create: PERMISSIONS.CREATE_VEHICLES } },
  { path: "/edit_entry", actions: { view: PERMISSIONS.EDIT_VEHICLES, edit: PERMISSIONS.EDIT_VEHICLES } },
  { path: "/view_entry", actions: { view: PERMISSIONS.SHOW_VEHICLES, show: PERMISSIONS.SHOW_VEHICLES } },

  {
    path: "/quotations_requests",
    actions: {
      view: PERMISSIONS.VIEW_QUOTATIONS,
      show: PERMISSIONS.SHOW_QUOTATIONS,
      create: PERMISSIONS.CREATE_QUOTATIONS,
      edit: PERMISSIONS.EDIT_QUOTATIONS,
    },
  },
  {
    path: "/client_offers",
    actions: {
      view: PERMISSIONS.VIEW_QUOTATIONS,
      show: PERMISSIONS.SHOW_QUOTATIONS,
      create: PERMISSIONS.CREATE_QUOTATIONS,
      edit: PERMISSIONS.EDIT_QUOTATIONS,
    },
  },
  {
    path: "/create_price_offer_request",
    actions: { view: PERMISSIONS.CREATE_QUOTATIONS, create: PERMISSIONS.CREATE_QUOTATIONS },
  },
  {
    path: "/price_offer_requests",
    actions: {
      view: PERMISSIONS.VIEW_QUOTATIONS,
      show: PERMISSIONS.SHOW_QUOTATIONS,
      create: PERMISSIONS.CREATE_QUOTATIONS,
      edit: PERMISSIONS.EDIT_QUOTATIONS,
    },
  },
  {
    path: "/quotations_requests_suppliers",
    actions: {
      view: PERMISSIONS.VIEW_TRIP_OFFERS,
      show: PERMISSIONS.SHOW_TRIP_OFFERS,
      create: PERMISSIONS.CREATE_TRIP_OFFERS,
      edit: PERMISSIONS.CREATE_TRIP_OFFERS,
    },
  },
  {
    path: "/provider_offers",
    actions: {
      view: PERMISSIONS.VIEW_TRIP_OFFERS,
      show: PERMISSIONS.SHOW_TRIP_OFFERS,
      create: PERMISSIONS.CREATE_TRIP_OFFERS,
    },
  },

  {
    path: "/sales-invoices",
    actions: {
      view: PERMISSIONS.VIEW_SALES_INVOICES,
      show: PERMISSIONS.SHOW_SALES_INVOICES,
      create: PERMISSIONS.CREATE_SALES_INVOICES,
      edit: PERMISSIONS.EDIT_SALES_INVOICES,
    },
  },
  {
    path: "/credit-notes",
    actions: {
      view: PERMISSIONS.VIEW_SALES_INVOICES,
      show: PERMISSIONS.SHOW_SALES_INVOICES,
      create: PERMISSIONS.CREATE_SALES_INVOICES,
      edit: PERMISSIONS.EDIT_SALES_INVOICES,
    },
  },
  {
    path: "/purchase_invoices",
    actions: {
      view: PERMISSIONS.VIEW_PURCHASE_INVOICES,
      show: PERMISSIONS.SHOW_PURCHASE_INVOICES,
      create: PERMISSIONS.CREATE_PURCHASE_INVOICES,
      edit: PERMISSIONS.EDIT_PURCHASE_INVOICES,
    },
  },
  {
    path: "/debit-notes",
    actions: {
      view: PERMISSIONS.VIEW_PURCHASE_INVOICES,
      show: PERMISSIONS.SHOW_PURCHASE_INVOICES,
      create: PERMISSIONS.CREATE_PURCHASE_INVOICES,
      edit: PERMISSIONS.EDIT_PURCHASE_INVOICES,
    },
  },
  {
    path: "/bonds",
    actions: {
      view: PERMISSIONS.VIEW_BONDS,
      show: PERMISSIONS.SHOW_BONDS,
      create: PERMISSIONS.CREATE_BONDS,
      edit: PERMISSIONS.EDIT_BONDS,
    },
  },
  { path: "/customer_vouchers", actions: { view: PERMISSIONS.VIEW_BONDS,
      show: PERMISSIONS.SHOW_BONDS, create: PERMISSIONS.CREATE_BONDS, edit: PERMISSIONS.EDIT_BONDS } },

  {
    path: "/chart_of_accounts",
    actions: {
      view: PERMISSIONS.VIEW_CHART_ACCOUNTS,
      show: PERMISSIONS.SHOW_CHART_ACCOUNTS,
      create: PERMISSIONS.CREATE_CHART_ACCOUNTS,
      edit: PERMISSIONS.EDIT_CHART_ACCOUNTS,
    },
  },
  { path: "/add_chart_accounts", actions: { view: PERMISSIONS.CREATE_CHART_ACCOUNTS, create: PERMISSIONS.CREATE_CHART_ACCOUNTS } },
  { path: "/edit_chart_accounts", actions: { view: PERMISSIONS.EDIT_CHART_ACCOUNTS, edit: PERMISSIONS.EDIT_CHART_ACCOUNTS } },
  { path: "/show_chart_accounts", actions: { view: PERMISSIONS.SHOW_CHART_ACCOUNTS, show: PERMISSIONS.SHOW_CHART_ACCOUNTS } },
  {
    path: "/manual_entries",
    actions: {
      view: PERMISSIONS.VIEW_JOURNAL_ENTRIES,
      show: PERMISSIONS.SHOW_JOURNAL_ENTRIES,
      create: PERMISSIONS.CREATE_JOURNAL_ENTRIES,
      edit: PERMISSIONS.EDIT_JOURNAL_ENTRIES,
    },
  },
  {
    path: "/easy_entries",
    actions: {
      view: PERMISSIONS.VIEW_JOURNAL_ENTRIES,
      show: PERMISSIONS.SHOW_JOURNAL_ENTRIES,
      create: PERMISSIONS.CREATE_JOURNAL_ENTRIES,
      edit: PERMISSIONS.EDIT_JOURNAL_ENTRIES,
    },
  },
  { path: "/add_easy_entries", actions: { view: PERMISSIONS.CREATE_JOURNAL_ENTRIES, create: PERMISSIONS.CREATE_JOURNAL_ENTRIES } },
  { path: "/edit_easy_entries", actions: { view: PERMISSIONS.EDIT_JOURNAL_ENTRIES, edit: PERMISSIONS.EDIT_JOURNAL_ENTRIES } },
  {
    path: "/cost_center_accounts",
    actions: {
      view: PERMISSIONS.VIEW_CHART_ACCOUNTS,
      show: PERMISSIONS.SHOW_CHART_ACCOUNTS,
      create: PERMISSIONS.CREATE_CHART_ACCOUNTS,
      edit: PERMISSIONS.EDIT_CHART_ACCOUNTS,
    },
  },
  { path: "/financial_years", actions: { view: PERMISSIONS.VIEW_CHART_ACCOUNTS,
      show: PERMISSIONS.SHOW_CHART_ACCOUNTS } },

  { path: "/profits", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/most_requested_services", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/active_accounts", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/taxes", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/tax_calculation", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/negative_accounts", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/lowest_cost_price", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/document_reception_reports", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/account_manager_request_reports", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/operator_trip_reports", actions: { view: PERMISSIONS.VIEW_REPORTS } },
  { path: "/trip_request_report", actions: { view: PERMISSIONS.VIEW_REPORTS } },
];

const SORTED_ROUTE_RULES = [...ROUTE_PERMISSION_RULES].sort(
  (a, b) => b.path.length - a.path.length
);

/**
 * @param {{ actions?: Record<string, string>, permission?: string }} rule
 * @param {'view' | 'show' | 'create' | 'edit'} action
 * @returns {string | null}
 */
export function getRequiredPermissionFromRule(rule, action) {
  if (!rule) return null;
  if (rule.actions) {
    if (action === "create") return rule.actions.create || null;
    if (action === "edit") return rule.actions.edit || null;
    if (action === "show") return rule.actions.show || null;
    return rule.actions.view || rule.permission || null;
  }
  return rule.permission || null;
}

/**
 * @param {string} pathname
 * @returns {{ rule: object, action: string, permission: string | null } | null}
 */
export function getRoutePermissionRule(pathname) {
  if (!pathname) return null;
  const path = pathname.split("?")[0] || "/";
  const action = detectPathAction(path);

  for (const rule of SORTED_ROUTE_RULES) {
    if (rule.exact) {
      if (path === rule.path) {
        return {
          rule,
          action,
          permission: getRequiredPermissionFromRule(rule, action),
        };
      }
      continue;
    }
    if (path === rule.path || path.startsWith(`${rule.path}/`)) {
      return {
        rule,
        action,
        permission: getRequiredPermissionFromRule(rule, action),
      };
    }
  }
  return null;
}

/**
 * @param {string} pathname
 * @param {Set<string>} keys
 * @param {{ enforce?: boolean }} [opts]
 */
export function canAccessPath(pathname, keys, opts = {}) {
  const { enforce = true } = opts;
  if (!enforce) return true;
  const matched = getRoutePermissionRule(pathname);
  if (!matched) return true;

  const { action, permission } = matched;
  // Create/edit/show without a mapped action permission → deny
  if (
    (action === "create" || action === "edit" || action === "show") &&
    !permission
  ) {
    return false;
  }
  if (!permission) return true;
  return checkPermission(permission, keys, { enforce: true, mode: "any" });
}
